import { useEffect } from 'react';

const AVAILABILITY_REFRESH_CHECK_INTERVAL_MS = 30 * 1000;

/**
 * Loads the chosen clinician's shown month, then keeps it fresh while the page
 * is visible: on a timer, and when the patient comes back to the tab.
 */
const useAvailabilityPolling = (
  clinicianId: string,
  month: string,
  loadMonth: (specialistId: string, month: string) => void,
): void => {
  useEffect(() => {
    if (!clinicianId) return undefined;

    loadMonth(clinicianId, month);

    // loadMonth throttles itself, so these only hit the network once the
    // cached month is older than the staleness threshold.
    const refreshWhenVisible = () => {
      if (document.visibilityState !== 'visible') return;
      loadMonth(clinicianId, month);
    };

    document.addEventListener('visibilitychange', refreshWhenVisible);
    const intervalId = setInterval(
      refreshWhenVisible,
      AVAILABILITY_REFRESH_CHECK_INTERVAL_MS,
    );

    return () => {
      document.removeEventListener('visibilitychange', refreshWhenVisible);
      clearInterval(intervalId);
    };
  }, [clinicianId, month, loadMonth]);
};

export default useAvailabilityPolling;
